export const FormSectionId = 'apply-now';
